function quantityAndPricesLicenses() {
	var firstRadioBtn = document.querySelector(".v-license-inputs").firstElementChild.firstElementChild;
	var licenseButton = document.querySelector("#v-license-atc-btn");
	var initialPrice = document.querySelector("#v-license-priceone").innerHTML;
	var initialPriceWithoutCurrency = Number(initialPrice.replace(/[^0-9.-]+/g, ""));
	var initialPriceDivided = initialPriceWithoutCurrency / 2;
	var licenseTotalRedPrice = document.querySelector(".v-license-red");
	var licenseTotalGreenPrice = document.querySelector(".v-license-total-now");
	var licenseTotalRedPriceText = document.querySelector(".v-license-total-regular");
	var licenseNNumberEls = document.getElementsByClassName("v-license-byN");
	var personalRadioEl = document.querySelector("#v-personalinput-radio");
	var additionalRadioEl = document.querySelector("#v-additionalinput-radio");
	var quantityInput = document.querySelector("#v-license-quantity-input");
	var mainQuantityBar = document.querySelector(".qty-selector__input");
  var currencySymbol = document.querySelector("#v-license-priceone").innerHTML.replace(/[0-9]\.?/g, '');
  var licensesText = document.querySelector("#v-license-licenses");
  var totalPriceSymbols = document.getElementsByClassName("v-license-csymbol");
	var modal = document.getElementById("v-license-myModal");
	var btn = document.getElementById("v-license-myBtn");
	var span = document.getElementsByClassName("v-license-close")[0];
  for(let i=0; i<totalPriceSymbols.length; i++) {
	totalPriceSymbols[i].innerHTML = currencySymbol;
	}
  
  
	btn.onclick = function() {
		modal.style.display = "block";
	}
	span.onclick = function() {
		modal.style.display = "none";
	}
	window.onclick = function(event) {
		if (event.target == modal) {
			modal.style.display = "none";
		}
	}

	$(".v-license-quantity-btn").on("click", function(ev) {
		document.querySelector(".v-license-labelwithquantity").firstElementChild.click();
		var currentQty = $('#v-license-quantity-input').val();
		var qtyDirection = $(this).data("direction");
		var newQty = 0;
		if (qtyDirection == "1") {
			newQty = parseInt(currentQty) + 1;
		} else if (qtyDirection == "-1") {
			newQty = parseInt(currentQty) - 1;
		}
		if (newQty == 1) {
			$(".decrement-quantity").attr("disabled", "disabled");
          licensesText.innerHTML = "license";
		}
		if (newQty > 1) {
			$(".decrement-quantity").removeAttr("disabled");
          licensesText.innerHTML = "licenses";
		}
		if (newQty > 0) {
			newQty = newQty.toString();
			$('#v-license-quantity-input').val(newQty);
        } else if (newQty > 10) {
			$(".decrement-quantity").attr("disabled", "disabled");
		}else {
			$('#v-license-quantity-input').val("1");
		}
		var redPrice = initialPriceWithoutCurrency * currentQty;
		var greenPrice = initialPriceWithoutCurrency + (initialPriceDivided * currentQty);
		licenseTotalRedPriceText.innerHTML = redPrice.toFixed(2);
		licenseTotalGreenPrice.innerHTML = greenPrice.toFixed(2);
		licenseTotalRedPrice.style.display = "block";
		licenseButton.innerHTML = "BUY 1 LICENSE + " + currentQty + " ADDITIONAL LICENSES";
		for (let i = 0; i < licenseNNumberEls.length; i++) {
			licenseNNumberEls[i].innerHTML = currentQty;
		}

	});

	function defaultStart() {
		firstRadioBtn.click();
		licenseButton.innerHTML = "BUY 1 LICENSE";
		licenseTotalRedPrice.style.display = "none";
		licenseTotalGreenPrice.innerHTML = initialPriceWithoutCurrency;
		for (let i = 0; i < licenseNNumberEls.length; i++) {
			licenseNNumberEls[i].innerHTML = "0";
		}
	}

	function personalRadioElClick() {
		licenseButton.innerHTML = "BUY 1 LICENSE";
		licenseTotalRedPrice.style.display = "none";
		licenseTotalGreenPrice.innerHTML = initialPriceWithoutCurrency;
		for (let i = 0; i < licenseNNumberEls.length; i++) {
			licenseNNumberEls[i].innerHTML = "0";
		}
		$('#v-license-quantity-input').val(0);
	}

	function additionalLicensedRadioClick() {
		var currentQty = $('#v-license-quantity-input').val();
		mainQuantityBar.value = Number(currentQty) + 1;
		if (currentQty == 1) {
			var redPrice = initialPriceWithoutCurrency * 2;
			var greenPrice = initialPriceWithoutCurrency + initialPriceDivided;
		} else if (currentQty == 2) {
			var redPrice = initialPriceWithoutCurrency * 3;
			var greenPrice = initialPriceWithoutCurrency + (initialPriceDivided * currentQty);
		} else {
			var redPrice = initialPriceWithoutCurrency * (Number(currentQty) + 1);
			var greenPrice = initialPriceWithoutCurrency + (initialPriceDivided * currentQty);
		}
		licenseTotalRedPriceText.innerHTML = redPrice.toFixed(2);
		licenseTotalGreenPrice.innerHTML = greenPrice.toFixed(2);
        
		licenseTotalRedPrice.style.display = "block";
      if (currentQty == 0) {
			licenseButton.innerHTML = "BUY 1 LICENSE";
		} else if (currentQty == 1) {
			licenseButton.innerHTML = "BUY 1 LICENSE + " + currentQty + " ADDITIONAL LICENSE";
        } else {
 			licenseButton.innerHTML = "BUY 1 LICENSE + " + currentQty + " ADDITIONAL LICENSES";
       }
		for (let i = 0; i < licenseNNumberEls.length; i++) {
			licenseNNumberEls[i].innerHTML = currentQty;
		}

	}


	personalRadioEl.addEventListener("click", personalRadioElClick);
	additionalRadioEl.addEventListener("click", additionalLicensedRadioClick);

	defaultStart();



	// observer for quantity change
	let inputBox = document.querySelector("#v-license-quantity-input");

	inputBox.addEventListener("input", function() {
		var currentQty = this.value;
		mainQuantityBar.value = Number(currentQty) + 1;
		if (currentQty == 1) {
			var redPrice = initialPriceWithoutCurrency * 2;
			var greenPrice = initialPriceWithoutCurrency + initialPriceDivided;
		} else if (currentQty == 2) {
			var redPrice = initialPriceWithoutCurrency * 3;
			var greenPrice = initialPriceWithoutCurrency + (initialPriceDivided * currentQty);
		} else {
			var redPrice = initialPriceWithoutCurrency * (Number(currentQty) + 1);
			var greenPrice = initialPriceWithoutCurrency + (initialPriceDivided * currentQty);
		}
		licenseTotalRedPriceText.innerHTML = redPrice.toFixed(2);
		licenseTotalGreenPrice.innerHTML = greenPrice.toFixed(2);
		licenseTotalRedPrice.style.display = "block";
		if (currentQty == 0) {
			licenseButton.innerHTML = "BUY 1 LICENSE";
		} else if (currentQty == 1) {
			licenseButton.innerHTML = "BUY 1 LICENSE + " + currentQty + " ADDITIONAL LICENSE";
        } else {
 			licenseButton.innerHTML = "BUY 1 LICENSE + " + currentQty + " ADDITIONAL LICENSES";
       }
		for (let i = 0; i < licenseNNumberEls.length; i++) {
			licenseNNumberEls[i].innerHTML = currentQty;
		}
	});

	observeElement(inputBox, "value", function(oldValue, newValue) {
		var currentQty = newValue;
		mainQuantityBar.value = Number(currentQty) + 1;
		if (currentQty == 1) {
			var redPrice = initialPriceWithoutCurrency * 2;
			var greenPrice = initialPriceWithoutCurrency + initialPriceDivided;
		} else if (currentQty == 2) {
			var redPrice = initialPriceWithoutCurrency * 3;
			var greenPrice = initialPriceWithoutCurrency + (initialPriceDivided * currentQty);
		} else {
			var redPrice = initialPriceWithoutCurrency * (Number(currentQty) + 1);
			var greenPrice = initialPriceWithoutCurrency + (initialPriceDivided * currentQty);
		}
		licenseTotalRedPriceText.innerHTML = redPrice.toFixed(2);
		licenseTotalGreenPrice.innerHTML = greenPrice.toFixed(2);
		licenseTotalRedPrice.style.display = "block";
		if (currentQty == 0) {
			licenseButton.innerHTML = "BUY 1 LICENSE";
		} else if (currentQty == 1) {
			licenseButton.innerHTML = "BUY 1 LICENSE + " + currentQty + " ADDITIONAL LICENSE";
        } else {
 			licenseButton.innerHTML = "BUY 1 LICENSE + " + currentQty + " ADDITIONAL LICENSES";
       }
		for (let i = 0; i < licenseNNumberEls.length; i++) {
			licenseNNumberEls[i].innerHTML = currentQty;
		}
	});

	function observeElement(element, property, callback, delay = 0) {
		let elementPrototype = Object.getPrototypeOf(element);
		if (elementPrototype.hasOwnProperty(property)) {
			let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);
			Object.defineProperty(element, property, {
				get: function() {
					return descriptor.get.apply(this, arguments);
				},
				set: function() {
					let oldValue = this[property];
					descriptor.set.apply(this, arguments);
					let newValue = this[property];
					if (typeof callback == "function") {
						setTimeout(callback.bind(this, oldValue, newValue), delay);
					}
					return newValue;
				}
			});
		}
	}
	// end

}

quantityAndPricesLicenses();


